import { fetch as fetchNetInfo, useNetInfo } from '@react-native-community/netinfo'
import { useEffect, type ReactNode } from 'react'

import { addErrorListener } from '@/src/general/utilities/fetcher/interceptors'
import { useTranslate } from '@/src/lang/useTranslate'

import { ICON } from '../enums/icons'
import { useToast } from './ToastContext'

export const ServiceUnavailable = (): ReactNode => {
  const { isInternetReachable } = useNetInfo()

  const { addToast } = useToast()
  const { t } = useTranslate()

  useEffect(() => {
    return addErrorListener((error) => {
      fetchNetInfo().then(({ isInternetReachable: isReachable }) => {
        if (error.code === 'ERR_NETWORK' && isReachable) {
          addToast({
            iconName: ICON.WIFI_OFF,
            colors: 'danger',
            message: t('app-service.unavailable.description'),
          })
        }
      })
    })
  }, [isInternetReachable, addToast, t])

  return null
}
